<template lang="pug">
app-entity.generic-party(
  :extra-data="extraData",
  v-if="!relation.multiple",
  :invert="invert",
  @close="$emit('close')",
  :relation="relation",
  :path="path === entity.name ? null : path",
  :entity="entity",
  v-bind="{ disabled, chips, selector, selectorOnly, showInfo,  parent , ignoreFields, isActive, parentPath, modalInstance, isAddEnabled }",
  :parentInstance="parentInstance"
  :replasable="false"
)
  template(v-slot:countryCode)
    v-text-field(
      v-model="instance.countryCode",
      label="Country Code"
      disabled
    )
  template(v-slot:countryName="{ disabled }")
    v-autocomplete(
      :value="instance.countryName",
      label="Country Name",
      :items="countries",
      item-text='name',
      return-object,
      v-bind="{ disabled, loading }",
      @change="setCountry",
    )
  template(v-for="(_, slot) in $slots")
    template(:slot="slot")
      slot(:name="slot")
</template>

<script>
import EntityMixin from '@/mixins'
import axios from 'axios'
export default {
  mixins: [EntityMixin],
  props: ['extraLoad', 'invert', 'chips', 'parentInstance', 'parent', 'entity', 'relation', 'path', 'parentPath', 'selector', 'selectorOnly', 'showInfo', 'extraData', 'isSection', 'isActive'],
  data: function () {
    return {
      loading: true,
      countries: [],
      //
    }
  },
  computed: {
    isAddEnabled() {
      return (!_.isEmpty(this.parent.name) && this.parent.name === 'OrderLine') ? false : true;
    }
  },
  methods: {
    async loadCountries() {
      try {
        this.loading = true;
        const endpoint = this.$fetchLoad(`Countries`, true)
        this.countries = (await axios.get(endpoint, { params: { pageSize: -1 }})).data.data;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
    setCountry(country) {
      this.$store.commit(this.setInstancePathAction, { path: this.path + '.countryName', value: country.name })
      this.$store.commit(this.setInstancePathAction, { path: this.path + '.countryCode', value: country.twoLetterCode })
    },
  },
  async mounted() {
    this.loadCountries();
  }
}
</script>
